import { render, staticRenderFns } from "./editor-controls.vue?vue&type=template&id=198e4c16"
import script from "./editor-controls.vue?vue&type=script&lang=js"
export * from "./editor-controls.vue?vue&type=script&lang=js"
import style0 from "./editor-controls.vue?vue&type=style&index=0&id=198e4c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports